import { atom, useRecoilState } from 'recoil';

const $beforeAfterPhotoState = atom<string[]>({
  key: 'beforeAfterPhotoState',
  default: []
});

export const useBeforeAfterPhotoState = () => {
  const [beforeAfterPhoto, setBeforeAfterPhoto] = useRecoilState(
    $beforeAfterPhotoState
  );

  return {
    beforeAfterPhoto,
    setBeforeAfterPhoto
  };
};
